import fetch from 'isomorphic-fetch';
import subscriptionsData from '../data/subscriptions.json';
import remotestatus from '../data/remoteStatus.json';
import vehicleData from '../data/vehicleCapabilities.json';
import updatedRemoteStatus from '../data/updateRemoteSubscription.json';
import authData from '../data/qrAuth.json';
import remotePollingData from '../data/remoteAuthPolling.json';

const getHeaders = () => ({
  'Content-Type': 'application/x-www-form-urlencoded',
});


const API_Prefix = process.env.REACT_APP_IDP_AUTHCODE_API;
const API_Prefix_forgeRock = process.env.REACT_APP_IDP_FORGEROCK_API;
/**
 * @name handleAPIError
 * @param {*} response response from api
 * @desc handles HTTP errors because fetch won't
 */
const handleAPIError = error => {
  const message = error.statusText || 'Unknown error';
  throw Error({ error, message });
};

/**
 * @name handleAPIResponse
 * @param {*} response response from api
 * @desc handles API response
 */
const handleAPIResponse = response => {
  if (!response.ok) {
    handleAPIError(response);
  }
  return response.json();
};

export const getVehicleData = () => vehicleData;

export const getSubscriptionData = () => subscriptionsData;

export const getRemoteStatus = () => remotestatus;

// export const getAuthData = () => authData;

export const getUpdatedRemoteStatus = () => updatedRemoteStatus;

// export const getRemotePollingData = () => remotePollingData;

// Post data for QRAuth
export const postAPI = (url, prefix = true, body, headers = {}) => {

  let urlPrefix = '';
  if (prefix) {
    urlPrefix = API_Prefix;
  }
  return fetch(`${urlPrefix}${url}`, {
    method: 'POST',
    body,
    headers: { ...getHeaders(), ...headers },
  })
    .then(handleAPIResponse)
    .catch(handleAPIError);
};

// Fetch/GET data from API
export const getAPI = () => fetch(`${API_Prefix_forgeRock}`, {
  method: 'GET',
  headers: { ...getHeaders(),
    Authorization: 'Basic aGVhZHVuaXQ6aGVhZHVuaXQ=' },
}).then(handleAPIResponse)
  .catch(handleAPIError);

// Put data
export const putAPI = (url, requestPayload) =>
  fetch(`${API_Prefix}${url}`, {
    method: 'PUT',
    body: JSON.stringify(requestPayload),
    headers: getHeaders(),
  }).then(handleAPIResponse);

// Delete data
export const deleteAPI = (url, requestPayload) =>
  fetch(`${API_Prefix}${url}`, {
    method: 'DELETE',
    body: JSON.stringify(requestPayload),
    headers: getHeaders(),
  }).then(handleAPIResponse);
